.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;
  margin-bottom: 28px;
}

.col {
  min-width: 0;
}

.col:first-child {
  border-right: 1px solid var(--border);
  padding-right: 40px;
}

.scheduleSection {
  border-top: 1px solid var(--border);
  padding-top: 24px;
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 0 40px;
  align-items: start;
}

.scheduleLabel {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--muted2);
  text-transform: uppercase;
  letter-spacing: .07em;
  padding-top: 6px;
}
